import { Laverie } from "./laverie";
import { Product } from "./product";
import { User } from "./user";
import { Account } from "./account";
import { ProductStatus, ProductType } from "./enum-type";

export interface FichePreparation {
    account: Account
    laverie: Laverie
    products: Product[]
    preparedFor: Date
    deliveredBy: User
    preparedBy: User
    optionsAutre: string
}

export class FichePreparationGen {
    // laverie.numeroDeContrat
    lnc: string

    // Lave-linge Type
    llt: string
    hllt: boolean

    // Lave-linge Contrat
    llc: string
    hllc: boolean

    // Lave-linge Prise
    llp: string
    hllp: boolean

    // Lave-linge Nbre (laverie.nbLaveLinge)
    lln: number
    hlln: boolean

    // Lave-linge Neuf (laverie.product.productType(Lave_Linge).productStatus(Nouveau))
    llne: number
    hllne: boolean

    // Lave-linge Occasion (laverie.product.productType(Lave_Linge).productStatus(Occasion))
    llo: number
    hllo: boolean

    // Lave-linge Prix lavage (laverie.tarifLavage)
    llpl: number
    hllpl: boolean

    // Lave-linge Mode Paiement (laverie.moyenDePaiement)
    llmp: string
    hllmp: boolean

    // Lave-linge Matériel paiement
    llmpa: string
    hllmpa: boolean

    // Sèche-linge Type
    slt: string
    hslt: boolean

    // Sèche-linge Contrat
    slc: string
    hslc: boolean

    // Sèche-linge PC 32A plexo
    sl32p: string
    hsl32p: boolean

    // Sèche-linge PC 32A hypra
    sl32h: string
    hsl32h: boolean

    // Sèche-linge Nbre (laverie.nbSecheLinge)
    sln: number
    hsln: boolean

    // Sèche-linge Neuf (laverie.product.productType(Seche_Linge).productStatus(Nouveau)
    slne: number
    hslne: boolean

    // Sèche-linge Occasion (laverie.product.productType(Seche_Linge).productStatus(Occasion)
    slo: number
    hslo: boolean

    // Sèche-linge PC 20A plexo
    sl20p: string
    hsl20p: boolean

    // Sèche-linge Prix séchage (laverie.tarifSechage)
    slps: number
    hslps: boolean

    // Sèche-linge Mode paiement (laverie.moyenDePaiement)
    slmp: string
    hslmp: boolean

    // Sèche-linge Matériel paiement
    slmpa: string
    hslmpa: boolean

    // Sèche-linge Temps séchage (laverie.tempsSechage)
    slts: number
    hslts: boolean

    // Stacked Type
    st: string
    hst: boolean

    // Stacked Contrat
    sc: string
    hsc: boolean

    // Stacked PC 32A hypra
    s32h: string
    hs32h: boolean

    // Stacked PC 32A plexo
    s32p: string
    hs32p: boolean

    // Stacked Nbre
    sn: number
    hsn: boolean

    // Stacked Neuf
    sne: number
    hsne: boolean

    // Stacked Occasion
    so: number
    hso: boolean

    // Stacked Matériel paiement
    smp: string
    hsmp: boolean

    // Stacked Prix lavage
    spl: number
    hspl: boolean

    // Stacked Prix séchage
    sps: number
    hsps: boolean

    // Stacked Temps séchage
    sts: number
    hsts: boolean

    // Stacked Mode paiement
    smpa: string
    hsmpa: boolean

    // Options chauffe eau
    oce: string
    hoce: boolean

    // Options Centrale
    oc: string
    hoc: boolean

    // Options Lessive
    ol: number
    hol: boolean

    // Options Réhausseur
    or: string
    hor: boolean

    // Options Clé caisse
    occ: string
    hocc: boolean

    // Options Clé ZB7
    ocz: string
    hocz: boolean

    // Options Jetons 11MS
    oj11: string
    hoj11: boolean

    // Options Jetons 55MS
    oj55: string
    hoj55: boolean

    // Options Autre
    oa: string
    hoa: boolean

    // products for the laverie
    lp: Product[]

    // preparedFor
    pf: string
    hpf: boolean

    // Livraison par (deliveredBy.name)
    dbn: string
    hdbn: boolean

    // Livraison par (deliveredBy.lastname)
    dbl: string
    hdbl: boolean

    // Préparé par (preparedBy.name)
    pbn: string
    hpbn: boolean

    // Préparé par (preparedBy.lastname)
    pbl: string
    hpbl: boolean
}

function getNumberOfProductTypeWithProductStatus(laverie: Laverie, productsByLaverie: Product[],pType: ProductType, pStatus: ProductStatus) {
    const products: Array<Product> = productsByLaverie ?? [];
    let counter = 0
    for (const p of products) {
        if (p.productType === pType && p.productStatus === pStatus) {
            counter = counter + 1
        }
    }
    return counter
}

export function flattenFichePreparation(input: FichePreparation): FichePreparationGen {
    const b = new FichePreparationGen();
    if (input.laverie) {
        b.lnc = input.laverie.numeroDeContrat.toString()

        // Lave-linge Type
        b.llt = "todo"
        b.hllt = true

        // Lave-linge Contrat
        b.llc = "todo"
        b.hllc = true

        // Lave-linge Prise
        b.llp = "todo"
        b.hllp = true

        // Lave-linge Nbre (laverie.nbLaveLinge)
        b.lln = input.laverie.nbLaveLinge
        b.hlln = true

        // Lave-linge Neuf (laverie.product.productType(Lave_Linge).productStatus(Nouveau))
        b.llne = getNumberOfProductTypeWithProductStatus(input.laverie, input.products, ProductType.LAVE_LINGE, ProductStatus.NOUVEAU)
        b.hllne = true

        // Lave-linge Occasion (laverie.product.productType(Lave_Linge).productStatus(Occasion))
        b.llo = getNumberOfProductTypeWithProductStatus(input.laverie, input.products, ProductType.LAVE_LINGE, ProductStatus.OCCASION)
        b.hllo = true

        // Lave-linge Prix lavage (laverie.tarifLavage)
        if (input.laverie.tarifLavage) {
            b.llpl = input.laverie.tarifLavage
            b.hllpl = true
        } else {
            b.hllpl = false
        }

        // Lave-linge Mode Paiement (laverie.moyenDePaiement)
        if (input.laverie.moyenDePaiement) {
            b.llmp = input.laverie.moyenDePaiement
            b.hllmp = true
        } else {
            b.hllmp = false
        }

        // Lave-linge Matériel paiement
        b.llmpa = "todo"
        b.hllmpa = true

        // Sèche-linge Type
        b.slt = "todo"
        b.hslt = true

        // Sèche-linge Contrat
        b.slc = "todo"
        b.hslc = true

        // Sèche-linge PC 32A plexo
        b.sl32p = "todo"
        b.hsl32p = true

        // Sèche-linge PC 32A hypra
        b.sl32h = "todo"
        b.hsl32h = true


        // Sèche-linge Nbre (laverie.nbSecheLinge)
        b.sln = input.laverie.nbSecheLinge
        b.hsln = true
        // Sèche-linge Neuf (laverie.product.productType(Seche_Linge).productStatus(Nouveau)
        b.slne = getNumberOfProductTypeWithProductStatus(input.laverie, input.products, ProductType.SECHE_LINGE, ProductStatus.NOUVEAU)
        b.hslne = true

        // Sèche-linge Occasion (laverie.product.productType(Seche_Linge).productStatus(Occasion)
        b.slo = getNumberOfProductTypeWithProductStatus(input.laverie, input.products, ProductType.SECHE_LINGE, ProductStatus.OCCASION)
        b.hslo = true

        // Sèche-linge PC 20A plexo
        b.sl20p = "todo"
        b.hsl20p = true

        // Sèche-linge Prix séchage (laverie.tarifSechage)
        if (input.laverie.tarifSechage) {
            b.slps = input.laverie.tarifSechage
            b.hslps = true
        } else {
            b.hslps = false
        }

        // Sèche-linge Mode paiement (laverie.moyenDePaiement)
        if (input.laverie.moyenDePaiement) {
            b.slmp = input.laverie.moyenDePaiement
            b.hslmp = true
        } else {
            b.hslmp = false
        }

        // Sèche-linge Matériel paiement
        b.slmpa = "todo"
        b.hslmpa = true

        // Sèche-linge Temps séchage (laverie.tempsSechage)
        if (input.laverie.tempsSechage) {
            b.slts = input.laverie.tempsSechage
            b.hslts = true
        } else {
            b.hslts = false
        }

        // Stacked Type
        b.st = "todo"
        b.hst = true

        // Stacked Contrat
        b.sc = "todo"
        b.hsc = true

        // Stacked PC 32A hypra
        b.s32h = "todo"
        b.hs32h = true

        // Stacked PC 32A plexo
        b.s32p = "todo"
        b.hs32p = true

        // Stacked Lavante Nbre
        if (input.laverie.nbStackedLave) {
            b.sn = input.laverie.nbStackedLave
            b.hsn = true
        } else {
            b.hsn = false
        }

        // Stacked Neuf
        b.sne = getNumberOfProductTypeWithProductStatus(input.laverie, input.products, ProductType.STACKED_LAVE_LINGE, ProductStatus.NOUVEAU)
        b.hsne = true

        // Stacked Occasion
        b.so = getNumberOfProductTypeWithProductStatus(input.laverie, input.products, ProductType.STACKED_LAVE_LINGE, ProductStatus.OCCASION)
        b.hso = true

        // Stacked Matériel paiement
        b.smp = "todo"
        b.hsmp = true

        // Stacked Prix lavage
        if (input.laverie.tarifLavage) {
            b.spl = input.laverie.tarifLavage
            b.hspl = true
        } else {
            b.hspl = false
        }

        // Stacked Prix séchage
        if (input.laverie.tarifSechage) {
            b.sps = input.laverie.tarifSechage
            b.hsps = true
        } else {
            b.hsps = false
        }

        // Stacked Temps séchage
        if (input.laverie.tempsSechage) {
            b.sts = input.laverie.tempsSechage
            b.hsts = true
        } else {
            b.hsts = false
        }

        // Stacked Mode paiement
        if (input.laverie.moyenDePaiement) {
            b.smpa = input.laverie.moyenDePaiement
            b.hsmpa = true
        } else {
            b.hsmpa = false
        }

        // Options chauffe eau
        b.oce = "todo"
        b.hoce = true

        // Options Centrale
        b.oc = "todo"
        b.hoc = true

        // Options Condensateur
        if (input.laverie.nbCondensateur) {
            b.ol = input.laverie.nbCondensateur
            b.hol = true
        } else {
            b.hol = false
        }

        // Options Réhausseur
        b.or = "todo"
        b.hor = true

        // Options Clé caisse
        b.occ = "todo"
        b.hocc = true

        // Options Clé ZB7
        b.ocz = "todo"
        b.hocz = true

        // Options Jetons 11MS
        b.oj11 = "todo"
        b.hoj11 = true

        // Options Jetons 55MS
        b.oj55 = "todo"
        b.hoj55 = true

        // Options Autre
        if (input.optionsAutre) {
            b.oa = input.optionsAutre
            b.hoa = true
        } else {
            b.hoa = false
        }
        // products for the laverie
        b.lp = input.products
    }
    // preparedFor
    if (input.preparedFor) {
        b.pf = input.preparedFor.toLocaleDateString()
        b.hpf = true
    } else {
        b.hpf = false
    }

    if (input.deliveredBy) {
        // Livraison par (deliveredBy.name)
        if (input.deliveredBy.name) {
            b.dbn = input.deliveredBy.name
            b.hdbn = true
        } else {
            b.hdbn = false
        }

        // Livraison par (deliveredBy.lastname)
        if (input.deliveredBy.lastname && !(input.deliveredBy.lastname == "Autre")) {
            b.dbl = input.deliveredBy.lastname
            b.hdbl = true
        } else {
            b.hdbl = false
        }
    } else {
        b.hdbn = false
        b.hdbl = false
    }
    if (input.preparedBy) {
        // Préparé par (preparedBy.name)
        if (input.preparedBy.name) {
            b.pbn = input.preparedBy.name
            b.hpbn = true
        } else {
            b.hpbn = false
        }

        // Préparé par (preparedBy.lastname)
        if (input.preparedBy.lastname && !(input.preparedBy.lastname == "Autre")) {
            b.pbl = input.preparedBy.lastname
            b.hpbl = true
        } else {
            b.hpbl = false
        }
    } else {
        b.hpbn = false
        b.hpbl = false
    }
    return b
}